export const AUTH_CONFIG = {
  fetchUserAfterLogin: true,
  autoRefreshToken: true,
  refreshTokenSecondsAhead: 300,
};
